import * as Sentry from '@sentry/react';

export function initSentry() {
  // Avoid double-init in hot reload
  // @ts-expect-error - internal flag
  if (window.__SENTRY_INIT__) return;
  // @ts-expect-error
  window.__SENTRY_INIT__ = true;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'production', // 'development' | 'production'
    tracesSampleRate: 0.1, // keep low in prod
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      // redact accidental PII fields if any show up later
      return event;
    },
  });

  // expose Sentry for BootSentinel
  // @ts-ignore
  (window as any).Sentry = Sentry;

  console.log('[Sentry] init done'); // visible in prod console
  try {
    Sentry.captureMessage('BOOT_SDK_READY', { level: 'info' });
  } catch {}
}

export { Sentry };
